/**
 * Shipping status enum representing the current state of a shipment
 */
export enum ShippingStatus {
  Pending = 'pending',
  Processing = 'processing',
  Shipped = 'shipped',
  Delivered = 'delivered',
  Failed = 'failed',
}

/**
 * Human-readable labels for shipping status values
 */
export const ShippingStatusLabels: Record<ShippingStatus, string> = {
  [ShippingStatus.Pending]: 'Pending',
  [ShippingStatus.Processing]: 'Processing',
  [ShippingStatus.Shipped]: 'Shipped',
  [ShippingStatus.Delivered]: 'Delivered',
  [ShippingStatus.Failed]: 'Failed',
};
